import React, { PureComponent } from 'react';
import CalendarSvg from '../UI/calendarSvg';
import SimpleCalender from '../calender/simple-calender';
import ReactDOM from 'react-dom';

class SearchWidgetSimple extends PureComponent{

  constructor(props){
    super(props);
 
    this.state = {
      searchIsOpen:false
    }

    this.searchbarClicked = this.searchbarClicked.bind(this);
  }


  searchbarClicked(){

    //Scroll into view
    ReactDOM.findDOMNode(this).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

    this.setState({searchIsOpen: !this.state.searchIsOpen});
  }

  render(){

    const { searchIsOpen } = this.state;

    return (
      <div className={`search-container round-corners isAdventure`}>
          
          <div className="search-panel mt1" onClick={this.searchbarClicked}>
              <div className="clearfix">
                  <div className="col col-12">
                    <div className="relative mb0">
                      <CalendarSvg fill="#B1ACA1" clazz="calendarSvg" /> 

                      <input
                        className={`adventure-planner`} 
                        type="search" 
                        id="search-input" 
                        placeholder={"Select departure date"} 
                        autoComplete="off" 
                        autoCorrect="off" 
                        />

                    </div>
                  </div>
              </div>
          </div>
     
          { searchIsOpen && <div className={`search-panel`}><SimpleCalender isPopularItineraries={true} /></div> }        

      </div>
      )
  }
}


export default SearchWidgetSimple; 